import React, { PropTypes } from 'react'
import './TankAnimated.css'
import Moment from 'moment'
import {Card, CardHeader, CardText} from 'material-ui/Card'
import {grey50, blue200, blue600} from 'material-ui/styles/colors'

const REQUEST_TANK_ROLE = 7
const REQUEST_BUILDING_ROLE = 31

const backgroundColor = grey50
const frontColor = blue600
const backColor = blue200

const styles = {
  container: {
    height: '150px',
    width: '100%',
    top: '50%',
    left: '50%',
    transform: ' translate(0, 0)',
    background: backgroundColor,
    overflow: 'hidden'
  },
  artContainer: {
    position: 'absolute',
    left: 0,
    top: 0,
    zIndex: 2,
    width: '100%',
    height: '100%',
    transform: 'translate(0, 100%)',
    background: frontColor
  },
  art: {
    width: '200%',
    position: 'absolute',
    bottom: '100%',
    marginBottom: '-1px'
  },
  artFront: {
    left: 0,
    fill: frontColor,
    animation: 'tankAnimatedToRight 3s infinite linear'
  },
  artBack: {
    right: 0,
    fill: backColor,
    animation: 'tankAnimatedToLeft 5s infinite linear'
  }
}

const getPercent = (information) => {
  if (information.updates.length > 0 && information.updates[0].data === 1) {
    return 20
  }
  let percent = 50
  if (information.updates.length >= 3) {
    const diff = Moment(information.updates[1].created_at).unix() - Moment(information.updates[2].created_at).unix()
    const currentDiff = Moment().unix() - Moment(information.updates[0].created_at).unix()
    percent = 100 - (Math.round(currentDiff / diff) * 100)
    if (percent > 85) {
      return 85
    }
    if (percent < 20) {
      return 20
    }
  }
  return percent
}

export const TankAnimatedArt = () => {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" style={{display: 'none'}}>
      <symbol id="tankAnimatedArt">
        <path d="M420,20c21.5-0.4,38.8-2.5,51.1-4.5c13.4-2.2,26.5-5.2,27.3-5.4C514,6.5,518,4.7,528.5,2.7c7.1-1.3,17.9-2.8,31.5-2.7c0,0,0,0,0,0v20H420z"></path>
        <path d="M420,20c-21.5-0.4-38.8-2.5-51.1-4.5c-13.4-2.2-26.5-5.2-27.3-5.4C326,6.5,322,4.7,311.5,2.7C304.3,1.4,293.6-0.1,280,0c0,0,0,0,0,0v20H420z"></path>
        <path d="M140,20c21.5-0.4,38.8-2.5,51.1-4.5c13.4-2.2,26.5-5.2,27.3-5.4C234,6.5,238,4.7,248.5,2.7c7.1-1.3,17.9-2.8,31.5-2.7c0,0,0,0,0,0v20H140z"></path>
        <path d="M140,20c-21.5-0.4-38.8-2.5-51.1-4.5c-13.4-2.2-26.5-5.2-27.3-5.4C46,6.5,42,4.7,31.5,2.7C24.3,1.4,13.6-0.1,0,0c0,0,0,0,0,0l0,20H140z"></path>
      </symbol>
    </svg>
  )
}

export const TankAnimated = ({id, description, building, informations}) => {
  const request = informations.find(information => {
    if (information.role === REQUEST_BUILDING_ROLE && information.role_identifier === building) {
      return true
    }
    if (information.role === REQUEST_TANK_ROLE && information.role_identifier === id) {
      return true
    }
    return false
  })

  const percent = getPercent(request)

  return (
    <Card style={styles.card}>
      <CardHeader
        title={description || "Reservatório"}
        textStyle={{padding: 0}}
        style={{paddingBottom: 0}}
      />
    <CardText>
        <div style={styles.container}>
           <div style={Object.assign({}, styles.artContainer, {transform: `translate(0, ${100 - percent}%)`})}>
             <svg key={1} viewBox="0 0 560 20" style={Object.assign({}, styles.art, styles.artBack)}>
               <use xlinkHref="#tankAnimatedArt"></use>
             </svg>
             <svg key={2} viewBox="0 0 560 20" style={Object.assign({}, styles.art, styles.artFront)}>
               <use xlinkHref="#tankAnimatedArt"></use>
             </svg>
           </div>
         </div>
     </CardText>
   </Card>
  )
}

TankAnimated.propTypes = {
  id: PropTypes.number.isRequired,
  description: PropTypes.string.isRequired,
  building: PropTypes.number.isRequired,
  informations: PropTypes.array.isRequired,
}



/** WEBPACK FOOTER **
 ** ./src/components/dashboard/TankAnimated.js
 **/